function GetQurter(duration, currentTime) {
    let FirstQuarter = duration / 4
    let secondQuarter = FirstQuarter * 2
    let ThirdQuarter = FirstQuarter * 3
    let FourthQuater = FirstQuarter * 4
    if (currentTime == parseInt(FirstQuarter)) {
        return 1
    }
    if (currentTime == parseInt(secondQuarter)) {
        return 2
    }
    if (currentTime == parseInt(ThirdQuarter)) {
        return 3
    }
    if (currentTime == parseInt(FourthQuater)) {
        return 4
    }
    return 0
}
function getQuarterWithRang(duration, currentTime) {
    let FirstQuarter = duration / 4
    let secondQuarter = FirstQuarter * 2
    let ThirdQuarter = FirstQuarter * 3
    let FourthQuater = FirstQuarter * 4
    if (currentTime < parseInt(FirstQuarter)) {
        return 0
    }
    if (currentTime >= parseInt(FirstQuarter) && currentTime < parseInt(secondQuarter)) {
        return 1
    }
    if (currentTime >= parseInt(secondQuarter) && currentTime < parseInt(ThirdQuarter)) {
        return 2
    }
    if (currentTime >= parseInt(ThirdQuarter) && currentTime < parseInt(FourthQuater)) {
        return 3
    }
    if (currentTime >= parseInt(FourthQuater)) {
        return 4
    }

    return 0
}

export function getTheExactQuarter(duration, currentTime, seeked) {

    if (!seeked) {
        return GetQurter(duration, currentTime)
    } else {
        return getQuarterWithRang(duration, currentTime)
    }
}